export default __webpack_public_path__ + "static/media/Logo Respinos 5.e613eb74.png";